var map = {
	"./AboutUs": [
		8230,
		423,
		658,
		230
	],
	"./AboutUs/": [
		8230,
		423,
		658,
		230
	],
	"./AboutUs/index": [
		8230,
		423,
		658,
		230
	],
	"./AboutUs/index.tsx": [
		8230,
		423,
		658,
		230
	],
	"./Courses": [
		7668,
		423,
		658,
		668
	],
	"./Courses/": [
		7668,
		423,
		658,
		668
	],
	"./Courses/index": [
		7668,
		423,
		658,
		668
	],
	"./Courses/index.tsx": [
		7668,
		423,
		658,
		668
	],
	"./Home": [
		8357,
		423,
		969,
		658,
		357
	],
	"./Home/": [
		8357,
		423,
		969,
		658,
		357
	],
	"./Home/index": [
		8357,
		423,
		969,
		658,
		357
	],
	"./Home/index.tsx": [
		8357,
		423,
		969,
		658,
		357
	],
	"./Registration": [
		2845,
		845
	],
	"./Registration/": [
		2845,
		845
	],
	"./Registration/index": [
		2845,
		845
	],
	"./Registration/index.tsx": [
		2845,
		845
	],
	"./Services": [
		3366,
		423,
		658,
		366
	],
	"./Services/": [
		3366,
		423,
		658,
		366
	],
	"./Services/index": [
		3366,
		423,
		658,
		366
	],
	"./Services/index.tsx": [
		3366,
		423,
		658,
		366
	],
	"./StudyAbroad": [
		8391,
		423,
		658,
		391
	],
	"./StudyAbroad/": [
		8391,
		423,
		658,
		391
	],
	"./StudyAbroad/index": [
		8391,
		423,
		658,
		391
	],
	"./StudyAbroad/index.tsx": [
		8391,
		423,
		658,
		391
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;